import customizer from './render-customizer'
import thumbnails from './render-thumbnails'

declare global {
  interface Window {
    VelorbisCustomizer: {
      customizer: typeof customizer
      thumbnails: typeof thumbnails
    }
  }
}

window.VelorbisCustomizer = {
  customizer,
  thumbnails
}
